import RestAPI from 'components/Common/restApi';

export default class QuickbooksOnlineAuthApi {
  static getAuthUrl({ reconnect = false } = {}) {
    return RestAPI.getWithQueryString('/pro/quickbooks/auth_async', { reconnect });
  }
}
